// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#AdminUserActionLog {
  /* 並び順に依存しないよう、幅の調整は条件ごとのクラスで指定する */
  /* イベント名は表示名が長いため広く、日時は "yyyy-mm-dd HH:mm" が収まる幅を確保する */
  /* 終了日時の時刻候補は injectTimes(開始側の刻みの1分前)で組み立てている。
     timeIntervals から自動生成される 00:00 だけが刻み由来のまま残るため、終了時刻の候補としては出さない */
  /* 「すべて」は個別項目と区切り、選択肢が多くてもスクロールで隠れないよう固定する */
  /* 一覧の再取得。アイコンだけの正方形にして、検索ボタンの右に控えめに添える */
  /* 一部だけ選択されている「すべて」。input は未チェックのため、塗りはクラス側で当てる */
  /* 詳細モーダル(よくある質問ポップアップと同じ構成。フッターは持たない) */
}
#AdminUserActionLog .header-download-button {
  width: fit-content;
  padding: 0 24px;
}
#AdminUserActionLog .action-log-toolbar {
  align-items: flex-end;
}
#AdminUserActionLog .search-container {
  position: relative;
  flex: 1 1;
}
#AdminUserActionLog .search-container-event {
  flex: 2 1;
}
#AdminUserActionLog .search-container-datetime {
  flex: 1 1;
}
#AdminUserActionLog .date-area {
  gap: 12px;
}
#AdminUserActionLog .date-input {
  display: block;
  width: 100%;
  height: 44px;
  padding: 12px;
  line-height: 12px;
  color: var(--dark-color-dark);
  background-color: var(--input-bg-color);
  background-clip: padding-box;
  border: 1px solid var(--border-color);
  appearance: none;
  border-radius: 4px;
  transition: all 0.15s;
}
#AdminUserActionLog .date-input:focus {
  border: 1px solid var(--primary-color-main);
  outline: 0;
}
#AdminUserActionLog .calender-dialog {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background-color: transparent;
  z-index: var(--z-index-local-over-2);
  /* 絶対配置でも幅の上限は包含ブロック(.search-container)になる。
     サイドメニューを開いて条件欄が狭まると時刻列が下へ回り込むため、内容なりの幅を確保する */
  width: max-content;
}
#AdminUserActionLog .end-datetime-picker .react-datepicker__time-list-item:not(.react-datepicker__time-list-item--injected) {
  display: none;
}
#AdminUserActionLog .date-calendar-icon {
  position: absolute;
  bottom: 15px;
  right: 10px;
  pointer-events: none;
}
#AdminUserActionLog .event-name-details {
  position: relative;
  display: block;
  width: 100%;
  height: 44px;
  line-height: 16px;
  color: var(--dark-color-dark);
  background-color: var(--input-bg-color);
  background-clip: padding-box;
  border: 1px solid var(--border-color);
  appearance: none;
  border-radius: 4px;
  transition: all 0.15s;
}
#AdminUserActionLog .event-name-summary {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 13px;
  list-style: none;
}
#AdminUserActionLog .event-name-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 500px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  padding: 8px;
  z-index: 1000;
}
#AdminUserActionLog .event-name-option {
  align-items: center;
  display: flex;
  gap: 6px;
  line-height: 1.2;
  letter-spacing: 1px;
}
#AdminUserActionLog .event-name-option input {
  display: none;
}
#AdminUserActionLog .event-name-option-all {
  position: sticky;
  top: 0;
  padding-bottom: 8px;
  background: #fff;
  border-bottom: 1px solid var(--border-weak-color);
}
#AdminUserActionLog .textinput-parent {
  height: 44px;
}
#AdminUserActionLog .search-button {
  min-width: 72px;
}
#AdminUserActionLog .reload-button {
  width: 40px;
  min-width: 40px;
  padding: 0;
  border: none;
  background-color: transparent;
  color: var(--font_active_sub_color);
  transition: background-color 0.2s, color 0.2s;
}
#AdminUserActionLog .reload-button:hover {
  background-color: var(--color-bg);
  color: var(--primary-color-main);
}
#AdminUserActionLog .reload-button:disabled {
  color: var(--disabled-font-color);
  cursor: default;
}
#AdminUserActionLog .checkbox-box {
  width: 16px;
  height: 16px;
  border: 1px solid var(--dark-color-dark);
  border-radius: 4px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.15s;
}
#AdminUserActionLog .event-name-option input:checked + .checkbox-box {
  background: var(--dark-color-dark);
}
#AdminUserActionLog .checkbox-box.partial {
  background: var(--dark-color-dark);
}
#AdminUserActionLog .checkbox-icon {
  color: #fff;
}
#AdminUserActionLog .operate-button {
  padding: 0;
  min-height: 28px;
  max-height: 28px;
  min-width: 72px;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background-color: var(--white-color-lightest);
}
#AdminUserActionLog .operate-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#AdminUserActionLog .scroll-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 64px;
  height: 64px;
  z-index: var(--z-index-local-over-5);
}
#AdminUserActionLog .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
#AdminUserActionLog .modal-content {
  background: #fff;
  width: 90%;
  max-width: 1280px;
  height: auto;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
#AdminUserActionLog .modal-header {
  min-height: 64px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
}
#AdminUserActionLog .modal-header .text-size-h2 {
  font-weight: 600;
  font-size: 1.25rem;
}
#AdminUserActionLog .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background-color: #f5f7fa;
}
#AdminUserActionLog .faq-config-card {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
}
#AdminUserActionLog .detail-row {
  width: 100%;
}
#AdminUserActionLog .detail-summary-row {
  width: 100%;
  flex-wrap: wrap;
}
#AdminUserActionLog .detail-summary-cell {
  flex: 1 1;
  min-width: 160px;
}
#AdminUserActionLog .detail-summary-cell:nth-child(2) {
  flex: 2 1;
}
#AdminUserActionLog .detail-summary-cell:nth-child(3) {
  flex: 1 1;
  margin-left: auto;
}
#AdminUserActionLog .detail-label {
  width: auto;
  flex: 1 1;
}
#AdminUserActionLog .detail-value {
  flex: 1 1;
  word-break: break-word;
  white-space: pre-wrap;
}
#AdminUserActionLog .detail-value-pre {
  white-space: pre-wrap;
  line-height: 1.6;
}
#AdminUserActionLog .detail-section-heading {
  font-weight: 800;
  letter-spacing: 1px;
}
#AdminUserActionLog .detail-grid-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  font-size: var(--text-size-small);
  color: var(--font_inactive_color);
}
#AdminUserActionLog .detail-grid-legend {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-shrink: 0;
}
#AdminUserActionLog .detail-grid-legend-before,
#AdminUserActionLog .detail-grid-legend-separator {
  color: var(--input-placeholder-color);
}
#AdminUserActionLog .detail-grid-legend-after {
  color: var(--font_active_color);
}
#AdminUserActionLog .detail-item-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}
#AdminUserActionLog .detail-item {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 16px;
  padding: 11px 0;
  border-bottom: 1px dashed var(--border-weak-color);
}
#AdminUserActionLog .detail-item:last-child {
  border-bottom: none;
}
#AdminUserActionLog .detail-item-key {
  width: 180px;
  min-width: 180px;
  color: var(--font_active_sub_color);
  font-size: var(--text-size-small);
}
#AdminUserActionLog .detail-item-value {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}
#AdminUserActionLog .detail-item-before {
  color: var(--input-placeholder-color);
  word-break: break-word;
  line-height: 1.6;
}
#AdminUserActionLog .detail-item-before.detail-item-removed {
  text-decoration: line-through;
}
#AdminUserActionLog .detail-item-arrow {
  color: var(--input-placeholder-color);
  font-size: var(--text-size-small);
}
#AdminUserActionLog .detail-item-after {
  word-break: break-word;
  line-height: 1.6;
}
#AdminUserActionLog .detail-item-list-diff .detail-item-after {
  font-weight: 700;
}
#AdminUserActionLog .inquiry-form-section-divided {
  padding-top: 11px;
  border-top: 1px dashed var(--border-weak-color);
}
#AdminUserActionLog .inquiry-form-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-head,
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-row {
  display: grid;
  grid-template-columns: 40px 64px 1fr 1.4fr 1.3fr 2.4fr;
  column-gap: 12px;
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-head {
  align-items: end;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--border-weak-color);
  font-size: var(--text-size-small);
  color: var(--input-placeholder-color);
  letter-spacing: 1px;
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-row {
  align-items: center;
  padding: 9px 0;
  border-bottom: 1px dashed var(--border-weak-color);
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-row:last-child {
  border-bottom: none;
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-cell {
  min-width: 0;
  word-break: break-word;
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-before {
  color: var(--input-placeholder-color);
  line-height: 1.55;
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-before.inquiry-form-grid-removed {
  text-decoration: line-through;
}
#AdminUserActionLog .inquiry-form-grid .inquiry-form-grid-after {
  line-height: 1.55;
}
#AdminUserActionLog .diff-after {
  color: var(--primary-color-main);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserActionLog.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAcI,mCAAA;EACA,uDAAA;EA6CA;mEAAA;EAoEA,4CAAA;EAiBA,yCAAA;EAqCA,iDAAA;EAiCA,wCAAA;AA7MJ;AATI;EACI,kBAAA;EACA,eAAA;AAWR;AATI;EACI,qBAAA;AAWR;AARI;EACI,kBAAA;EACA,SAAA;AAUR;AALI;EACI,SAAA;AAOR;AAJI;EACI,SAAA;AAMR;AAHI;EACI,SAAA;AAKR;AAFI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAIR;AAFQ;EACI,2CAAA;EACA,UAAA;AAIZ;AAAI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,6BAAA;EACA,oCAAA;EACA;kDAAA;EAEA,kBAAA;AAER;AAGI;EACI,aAAA;AADR;AAII;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AAFR;AAKI;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAHR;AAMI;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;AAJR;AAOI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,kBAAA;EACA,SAAA;EACA,OAAA;EAEA,WAAA;EACA,iBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,sBAAA;EACA,YAAA;EAEA,aAAA;AATR;AAYI;EACI,mBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AAVR;AAaI;EACI,aAAA;AAXR;AAeI;EACI,gBAAA;EACA,MAAA;EACA,mBAAA;EACA,gBAAA;EACA,iDAAA;AAbR;AAgBI;EACI,YAAA;AAdR;AAiBI;EACI,eAAA;AAfR;AAmBI;EACI,WAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;EACA,mCAAA;EACA,6CAAA;AAjBR;AAmBQ;EACI,iCAAA;EACA,gCAAA;AAjBZ;AAoBQ;EACI,iCAAA;EACA,eAAA;AAlBZ;AAsBI;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AApBR;AAuBI;EACI,kCAAA;AArBR;AAyBI;EACI,kCAAA;AAvBR;AA0BI;EACI,WAAA;AAxBR;AA2BI;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,6CAAA;AAzBR;AA2BQ;EACI,wCAAA;EACA,8BAAA;AAzBZ;AA6BI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AA3BR;AA+BI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7BR;AAgCI;EACI,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EAGA,gBAAA;AAhCR;AAmCI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AAjCR;AAmCQ;EACI,gBAAA;EACA,kBAAA;AAjCZ;AAsCI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AApCR;AAuCI;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;AArCR;AA6CI;EACI,WAAA;AA3CR;AA8CI;EACI,WAAA;EACA,eAAA;AA5CR;AA+CI;EACI,SAAA;EACA,gBAAA;AA7CR;AA+CQ;EACI,SAAA;AA7CZ;AAgDQ;EACI,SAAA;EACA,iBAAA;AA9CZ;AAkDI;EACI,WAAA;EACA,SAAA;AAhDR;AAmDI;EACI,SAAA;EACA,sBAAA;EACA,qBAAA;AAjDR;AAoDI;EACI,qBAAA;EACA,gBAAA;AAlDR;AAuDI;EACI,gBAAA;EACA,mBAAA;AArDR;AAyDI;EACI,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,iCAAA;EACA,iCAAA;AAvDR;AA2DI;EACI,aAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;AAzDR;AA4DI;;EAEI,qCAAA;AA1DR;AA6DI;EACI,+BAAA;AA3DR;AA8DI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AA5DR;AA+DI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;EACA,kDAAA;AA7DR;AA+DQ;EACI,mBAAA;AA7DZ;AAiEI;EACI,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,iCAAA;AA/DR;AAkEI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AAhER;AAmEI;EACI,qCAAA;EACA,sBAAA;EACA,gBAAA;AAjER;AAoEQ;EACI,6BAAA;AAlEZ;AAsEI;EACI,qCAAA;EACA,iCAAA;AApER;AAuEI;EACI,sBAAA;EACA,gBAAA;AArER;AA0EI;EACI,gBAAA;AAxER;AA8EI;EACI,iBAAA;EACA,+CAAA;AA5ER;AAgFI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AA9ER;AAgFQ;;EAEI,aAAA;EACA,sDAAA;EACA,gBAAA;AA9EZ;AAiFQ;EACI,gBAAA;EACA,mBAAA;EACA,iDAAA;EACA,iCAAA;EACA,qCAAA;EACA,mBAAA;AA/EZ;AAkFQ;EAEI,mBAAA;EACA,cAAA;EACA,kDAAA;AAjFZ;AAmFY;EACI,mBAAA;AAjFhB;AAqFQ;EACI,YAAA;EACA,sBAAA;AAnFZ;AAsFQ;EACI,qCAAA;EACA,iBAAA;AApFZ;AAwFY;EACI,6BAAA;AAtFhB;AA0FQ;EACI,iBAAA;AAxFZ;AA4FI;EACI,gCAAA;AA1FR","sourcesContent":["#AdminUserActionLog {\r\n    .header-download-button {\r\n        width: fit-content;\r\n        padding: 0 24px;\r\n    }\r\n    .action-log-toolbar {\r\n        align-items: flex-end;\r\n    }\r\n\r\n    .search-container {\r\n        position: relative;\r\n        flex: 1 1 0;\r\n    }\r\n\r\n    /* 並び順に依存しないよう、幅の調整は条件ごとのクラスで指定する */\r\n    /* イベント名は表示名が長いため広く、日時は \"yyyy-mm-dd HH:mm\" が収まる幅を確保する */\r\n    .search-container-event {\r\n        flex: 2 1 0;\r\n    }\r\n\r\n    .search-container-datetime {\r\n        flex: 1 1 0;\r\n    }\r\n\r\n    .date-area {\r\n        gap: 12px;\r\n    }\r\n\r\n    .date-input {\r\n        display: block;\r\n        width: 100%;\r\n        height: 44px;\r\n        padding: 12px;\r\n        line-height: 12px;\r\n        color: var(--dark-color-dark);\r\n        background-color: var(--input-bg-color);\r\n        background-clip: padding-box;\r\n        border: 1px solid var(--border-color);\r\n        appearance: none;\r\n        border-radius: 4px;\r\n        transition: all 0.15s;\r\n\r\n        &:focus {\r\n            border: 1px solid var(--primary-color-main);\r\n            outline: 0;\r\n        }\r\n    }\r\n\r\n    .calender-dialog {\r\n        position: absolute;\r\n        top: 100%;\r\n        right: 0;\r\n        margin-top: 8px;\r\n        background-color: transparent;\r\n        z-index: var(--z-index-local-over-2);\r\n        /* 絶対配置でも幅の上限は包含ブロック(.search-container)になる。\r\n           サイドメニューを開いて条件欄が狭まると時刻列が下へ回り込むため、内容なりの幅を確保する */\r\n        width: max-content;\r\n    }\r\n\r\n    /* 終了日時の時刻候補は injectTimes(開始側の刻みの1分前)で組み立てている。\r\n       timeIntervals から自動生成される 00:00 だけが刻み由来のまま残るため、終了時刻の候補としては出さない */\r\n    .end-datetime-picker .react-datepicker__time-list-item:not(.react-datepicker__time-list-item--injected) {\r\n        display: none;\r\n    }\r\n\r\n    .date-calendar-icon {\r\n        position: absolute;\r\n        bottom: 15px;\r\n        right: 10px;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .event-name-details {\r\n        position: relative;\r\n        display: block;\r\n        width: 100%;\r\n        height: 44px;\r\n        line-height: 16px;\r\n        color: var(--dark-color-dark);\r\n        background-color: var(--input-bg-color);\r\n        background-clip: padding-box;\r\n        border: 1px solid var(--border-color);\r\n        appearance: none;\r\n        border-radius: 4px;\r\n        transition: all 0.15s;\r\n    }\r\n\r\n    .event-name-summary {\r\n        align-items: center;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        padding: 13px;\r\n        list-style: none;\r\n    }\r\n\r\n    .event-name-options {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 12px;\r\n\r\n        position: absolute;\r\n        top: 100%;\r\n        left: 0;\r\n\r\n        width: 100%;\r\n        max-height: 500px;\r\n        overflow-y: auto;\r\n\r\n        background: white;\r\n        border: 1px solid #ccc;\r\n        padding: 8px;\r\n\r\n        z-index: 1000;\r\n    }\r\n\r\n    .event-name-option {\r\n        align-items: center;\r\n        display: flex;\r\n        gap: 6px;\r\n        line-height: 1.2;\r\n        letter-spacing: 1px;\r\n    }\r\n\r\n    .event-name-option input {\r\n        display: none;\r\n    }\r\n\r\n    /* 「すべて」は個別項目と区切り、選択肢が多くてもスクロールで隠れないよう固定する */\r\n    .event-name-option-all {\r\n        position: sticky;\r\n        top: 0;\r\n        padding-bottom: 8px;\r\n        background: #fff;\r\n        border-bottom: 1px solid var(--border-weak-color);\r\n    }\r\n\r\n    .textinput-parent {\r\n        height: 44px;\r\n    }\r\n\r\n    .search-button {\r\n        min-width: 72px;\r\n    }\r\n\r\n    /* 一覧の再取得。アイコンだけの正方形にして、検索ボタンの右に控えめに添える */\r\n    .reload-button {\r\n        width: 40px;\r\n        min-width: 40px;\r\n        padding: 0;\r\n        border: none;\r\n        background-color: transparent;\r\n        color: var(--font_active_sub_color);\r\n        transition: background-color 0.2s, color 0.2s;\r\n\r\n        &:hover {\r\n            background-color: var(--color-bg);\r\n            color: var(--primary-color-main);\r\n        }\r\n\r\n        &:disabled {\r\n            color: var(--disabled-font-color);\r\n            cursor: default;\r\n        }\r\n    }\r\n\r\n    .checkbox-box {\r\n        width: 16px;\r\n        height: 16px;\r\n        border: 1px solid var(--dark-color-dark);\r\n        border-radius: 4px;\r\n        background: #fff;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        transition: all 0.15s;\r\n    }\r\n\r\n    .event-name-option input:checked + .checkbox-box {\r\n        background: var(--dark-color-dark);\r\n    }\r\n\r\n    /* 一部だけ選択されている「すべて」。input は未チェックのため、塗りはクラス側で当てる */\r\n    .checkbox-box.partial {\r\n        background: var(--dark-color-dark);\r\n    }\r\n\r\n    .checkbox-icon {\r\n        color: #fff;\r\n    }\r\n\r\n    .operate-button {\r\n        padding: 0;\r\n        min-height: 28px;\r\n        max-height: 28px;\r\n        min-width: 72px;\r\n        border-radius: 14px;\r\n        border: 1px solid var(--border-weak-color);\r\n        background-color: var(--white-color-lightest);\r\n\r\n        &:hover{\r\n            background-color: var(--dark-color-main);\r\n            color: var(--white-color-main);\r\n        }\r\n    }\r\n\r\n    .scroll-button {\r\n        position: fixed;\r\n        bottom: 16px;\r\n        right: 16px;\r\n        width: 64px;\r\n        height: 64px;\r\n        z-index: var(--z-index-local-over-5);\r\n    }\r\n\r\n    /* 詳細モーダル(よくある質問ポップアップと同じ構成。フッターは持たない) */\r\n    .modal-overlay {\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100vw;\r\n        height: 100vh;\r\n        background-color: rgba(0, 0, 0, 0.5);\r\n        z-index: 9999;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    .modal-content {\r\n        background: #fff;\r\n        width: 90%;\r\n        max-width: 1280px;\r\n        height: auto;\r\n        max-height: 90vh;\r\n        border-radius: 8px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n        // フッターを持たないため最下部が背景色付きのボディになる\r\n        // 角丸からはみ出さないように切り取る\r\n        overflow: hidden;\r\n    }\r\n\r\n    .modal-header {\r\n        min-height: 64px;\r\n        padding: 16px 24px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        border-bottom: 1px solid #e0e0e0;\r\n\r\n        .text-size-h2 {\r\n            font-weight: 600;\r\n            font-size: 1.25rem;\r\n        }\r\n    }\r\n\r\n    // ヘッダー右上の閉じるボタン(フッターを持たないため、これが唯一の閉じるボタンになる)\r\n    .modal-body {\r\n        flex: 1;\r\n        overflow-y: auto;\r\n        padding: 24px;\r\n        background-color: #f5f7fa;\r\n    }\r\n\r\n    .faq-config-card {\r\n        background: #ffffff;\r\n        padding: 24px;\r\n        border-radius: 8px;\r\n    }\r\n\r\n    // .detail-info-card,\r\n    // .detail-chatlog-card {\r\n    //     width: 100%;\r\n    // }\r\n\r\n    .detail-row {\r\n        width: 100%;\r\n    }\r\n\r\n    .detail-summary-row {\r\n        width: 100%;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .detail-summary-cell {\r\n        flex: 1 1 0;\r\n        min-width: 160px;\r\n\r\n        &:nth-child(2) {\r\n            flex: 2 1 0;\r\n        }\r\n\r\n        &:nth-child(3) {\r\n            flex: 1 1 0;\r\n            margin-left: auto;\r\n        }\r\n    }\r\n\r\n    .detail-label {\r\n        width: auto;\r\n        flex: 1 1 0%;\r\n    }\r\n\r\n    .detail-value {\r\n        flex: 1;\r\n        word-break: break-word;\r\n        white-space: pre-wrap;\r\n    }\r\n\r\n    .detail-value-pre {\r\n        white-space: pre-wrap;\r\n        line-height: 1.6;\r\n    }\r\n\r\n    // 詳細項目の定義リスト(ラベル列の幅を固定して値の頭を揃える)\r\n    // 見出しはサマリーの「アカウント名」等と同じ見た目にする(.detail-label + .text-bold 相当)\r\n    .detail-section-heading {\r\n        font-weight: 800;\r\n        letter-spacing: 1px;\r\n    }\r\n\r\n    // フォーム項目定義の見出しは表のヘッダーと同じ扱いのため、一覧の列見出しに色を揃える\r\n    .detail-grid-heading {\r\n        display: flex;\r\n        align-items: baseline;\r\n        justify-content: space-between;\r\n        gap: 16px;\r\n        font-size: var(--text-size-small);\r\n        color: var(--font_inactive_color);\r\n    }\r\n\r\n    // 2段になっているセルの読み方を示す凡例。色は .inquiry-form-grid-before / -after と揃える\r\n    .detail-grid-legend {\r\n        display: flex;\r\n        align-items: baseline;\r\n        gap: 8px;\r\n        flex-shrink: 0;\r\n    }\r\n\r\n    .detail-grid-legend-before,\r\n    .detail-grid-legend-separator {\r\n        color: var(--input-placeholder-color);\r\n    }\r\n\r\n    .detail-grid-legend-after {\r\n        color: var(--font_active_color);\r\n    }\r\n\r\n    .detail-item-list {\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: 100%;\r\n    }\r\n\r\n    .detail-item {\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: baseline;\r\n        gap: 16px;\r\n        padding: 11px 0;\r\n        border-bottom: 1px dashed var(--border-weak-color);\r\n\r\n        &:last-child {\r\n            border-bottom: none;\r\n        }\r\n    }\r\n\r\n    .detail-item-key {\r\n        width: 180px;\r\n        min-width: 180px;\r\n        color: var(--font_active_sub_color);\r\n        font-size: var(--text-size-small);\r\n    }\r\n\r\n    .detail-item-value {\r\n        flex: 1;\r\n        min-width: 0;\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: baseline;\r\n        gap: 10px;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .detail-item-before {\r\n        color: var(--input-placeholder-color);\r\n        word-break: break-word;\r\n        line-height: 1.6;\r\n\r\n        // 変更後が無い(値を消した)場合は、無くなったことが分かるよう打ち消し線を引く\r\n        &.detail-item-removed {\r\n            text-decoration: line-through;\r\n        }\r\n    }\r\n\r\n    .detail-item-arrow {\r\n        color: var(--input-placeholder-color);\r\n        font-size: var(--text-size-small);\r\n    }\r\n\r\n    .detail-item-after {\r\n        word-break: break-word;\r\n        line-height: 1.6;\r\n    }\r\n\r\n    // 変更前と対比させる表でのみ、変更後の値を太字にする\r\n    // フィルター内容や追加・削除の内容のように変更前が無い表は、太字にする対比相手がいないため通常の太さのままにする\r\n    .detail-item-list-diff .detail-item-after {\r\n        font-weight: 700;\r\n    }\r\n\r\n    // 上に定義リストがある場合だけ区切り線を引く\r\n    // 定義リストの最終行は border-bottom を消しているため、境目の線はこちら側で持つ\r\n    // padding-top は .detail-item の padding と揃えて行間のリズムを崩さない\r\n    .inquiry-form-section-divided {\r\n        padding-top: 11px;\r\n        border-top: 1px dashed var(--border-weak-color);\r\n    }\r\n\r\n    // フォーム項目定義は列数が多いためグリッドで揃え、変更前を上段・変更後を下段に置く\r\n    .inquiry-form-grid {\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: 100%;\r\n\r\n        .inquiry-form-grid-head,\r\n        .inquiry-form-grid-row {\r\n            display: grid;\r\n            grid-template-columns: 40px 64px 1fr 1.4fr 1.3fr 2.4fr;\r\n            column-gap: 12px;\r\n        }\r\n\r\n        .inquiry-form-grid-head {\r\n            align-items: end;\r\n            padding-bottom: 6px;\r\n            border-bottom: 1px solid var(--border-weak-color);\r\n            font-size: var(--text-size-small);\r\n            color: var(--input-placeholder-color);\r\n            letter-spacing: 1px;\r\n        }\r\n\r\n        .inquiry-form-grid-row {\r\n            // 変更があるセルだけが2段になるため、1段のセルは上下中央に置いて高さを揃える\r\n            align-items: center;\r\n            padding: 9px 0;\r\n            border-bottom: 1px dashed var(--border-weak-color);\r\n\r\n            &:last-child {\r\n                border-bottom: none;\r\n            }\r\n        }\r\n\r\n        .inquiry-form-grid-cell {\r\n            min-width: 0;\r\n            word-break: break-word;\r\n        }\r\n\r\n        .inquiry-form-grid-before {\r\n            color: var(--input-placeholder-color);\r\n            line-height: 1.55;\r\n\r\n            // 変更後が無い(値を消した/項目ごと削除した)場合だけ、無くなったことが分かるよう打ち消し線を引く\r\n            // 文字サイズは見出しではなく変更後の値と揃える(小さいと削除内容が読み取りにくいため)\r\n            &.inquiry-form-grid-removed {\r\n                text-decoration: line-through;\r\n            }\r\n        }\r\n\r\n        .inquiry-form-grid-after {\r\n            line-height: 1.55;\r\n        }\r\n    }\r\n\r\n    .diff-after {\r\n        color: var(--primary-color-main);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
